import { z } from 'zod'

import { DateZod } from '../common/date-zod'

export const SoquijSecretZod = z.object({
  token: z.string(),
  expiresAt: DateZod,
})
